import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { setLenis } from "@/lib/lenis";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollTop />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Legal kind="privacy" />} />
          <Route path="/terms" element={<Legal kind="terms" />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
